import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createUser({ commit }, data) {
      try {
        return await api.post('/company/users', data)
      } catch (error) {
        throw error
      }
    },

    async getUsers({ commit }) {
      try {
        const response = await api.get('/company/users')
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getUser({ commit }, id) {
      try {
        const response = await api.get(`/company/users/${id}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateUser({ commit }, data) {
      try {
        return await api.put(`/company/users/${data.id}`, data)
      } catch (error) {
        throw error
      }
    },

    async updateUserPassword({ commit }, data) {
      try {
        return await api.put(`/company/users/${data.id}/password`, data)
      } catch (error) {
        throw error
      }
    },

    async deleteUser({ commit }, id) {
      try {
        return await api.delete(`/company/users/${id}`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
